import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';
import { clearPreview, getPreviewState } from '../lib/preview.js';
import { routes } from '../routes.js';

/**
 * Persistent strip shown across the top of the portal whenever an agency
 * admin is read-only previewing as a client contact. Never ambiguous:
 * names the impersonated contact, names the underlying agency user, and
 * gives a single "Exit preview" action that returns to the agency view.
 */
export function PreviewBanner() {
  const { previewMode, realAgencyAuth } = useAuth();
  const navigate = useNavigate();
  const preview = getPreviewState();
  if (!previewMode || !preview) return null;

  return (
    <div
      className="border-b border-status-amber/50 bg-status-amber/15 text-scope-navy"
      role="status"
    >
      <div className="mx-auto flex max-w-content flex-col gap-2 px-4 py-2.5 text-sm sm:flex-row sm:items-center sm:justify-between md:px-8">
        <div className="flex items-start gap-2">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mt-0.5 shrink-0 text-status-amber"
            aria-hidden="true"
          >
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
          <div>
            <p className="font-medium">
              Previewing as <strong>{preview.contactName}</strong> ({preview.clientName})
            </p>
            <p className="text-xs text-scope-text-muted">
              Read-only view of what this contact sees.
              {realAgencyAuth?.email ? ` Signed in as ${realAgencyAuth.email}.` : ''}
            </p>
          </div>
        </div>
        <button
          onClick={() => {
            clearPreview();
            navigate(routes.clients);
          }}
          className="shrink-0 self-start rounded-md bg-scope-navy px-3 py-1.5 text-xs font-medium text-white transition hover:bg-scope-navy-soft sm:self-auto"
        >
          Exit preview
        </button>
      </div>
    </div>
  );
}
